import axios from 'axios';
import { router } from '../routing';

const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true,
    timeout: 30000,
});

function handleError(error) {
    if (!error.response || error.response.status > 500) {
        router.push({ name: 'Error' });
    }
    switch (error.response.status) {
        case 401:
            localStorage.removeItem('truthtree-session');
            router.push({ name: 'Login' });
            return;
        default: 
            router.push({ name: 'Error' });
    }
}

export default {
    get: function(path) {
        return client.get(path).catch(error => handleError(error));
    },
    post: function(path, data) {
        return client.post(path, data).catch(error => handleError(error));
    },
    put: function(path, data) {
        return client.put(path, data).catch(error => handleError(error));
    },
    delete: function(path) {
        return client.delete(path).catch(error => handleError(error));
    }
};
